export default __webpack_public_path__ + "static/media/azienda-img.a9458c09.png";